import React, { useState, useEffect } from "react";
import bannerimg from "../../utils/images/banner_img.png";
import icon15 from "../../utils/images/icon15.png";
import image1 from "../../utils/images/image1.png";
import icon3 from "../../utils/images/icon3.svg";
import icon4 from "../../utils/images/icon4.svg";
import icon5 from "../../utils/images/icon5.svg";
import icon6 from "../../utils/images/icon6.png";
import icon7 from "../../utils/images/icon7.png";
import icon30 from "../../utils/images/icon31.png";
import icon16 from "../../utils/images/icon16.png";
import icon8 from "../../utils/images/icon8.png";
import icon17 from "../../utils/images/icon17.png";
import icon18 from "../../utils/images/icon18.png";
import icon19 from "../../utils/images/icon19.png";
import icon20 from "../../utils/images/icon20.png";
import icon10 from "../../utils/images/icon10.svg";
import icon11 from "../../utils/images/icon11.svg";
import icon12 from "../../utils/images/icon12.svg";
import icon13 from "../../utils/images/icon13.svg";
import icon14 from "../../utils/images/icon14.svg";
import icon1 from "../../utils/images/icon1.svg";
import icon2 from "../../utils/images/icon2.svg";
import image2 from "../../utils/images/image2.png";
import image3 from "../../utils/images/image3.png";
import image4 from "../../utils/images/image4.png";
import CustomLoader from "../../Compoments/CustomeLoader";
import Modal from "react-bootstrap/Modal";
import Form from 'react-bootstrap/Form';
import { config } from "../../config"
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// gsap.registerPlugin(ScrollTrigger);


function Home() {
  const [loading, setLoader] = useState(true);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();
  // const number = useRef(null);


  // useEffect(() => {
  //   gsap.from(".text-animation", {
  //     scrollTrigger: {
  //       trigger: ".text-animation",
  //       start: "top bottom",
  //       end: "top 400px",
  //       scrub: 1,
  //       stagger: {
  //         each: 0.6,
  //         from: "start",
  //       },
  //     },
  //     xPercent: -200,
  //     opacity: 0,
  //   });
  //   gsap.from(".text-animations", {
  //     scrollTrigger: {
  //       trigger: ".text-animations",
  //       start: "top bottom+=100px",
    
  //       toggleActions: "play complete none reset",
  //       stagger: {
  //         each: 0.6,
  //         from: "start",
  //       },
  //     },
  //     xPercent: 100,
  //     opacity: 0.5,
  //     duration: 1 
  //   });
  //   ScrollTrigger.create({
  //     trigger: ".text-animation",
  //     start: "top bottom+=-200px",
  //     endTrigger: ".text-animations",
  //     end: "bottom top",
  //   });
  
  //   ScrollTrigger.refresh()

    
  // }, []);

  const [inquiry, setInquiry] = useState({
    full_name: "",
    email: "",
    phone_number: "",
    // solicitor_type: "solo",
    firm_name: "",
    user_count: "2-5",
    current_software: "",
    game_changing_feature: "",
    demo_access_opt_in: "false",
    refer_colleague: "",
    colleague_email: "",
  });

  const [errors, setErrors] = useState({});


  const validate = () => {
    const newErrors = {};

    if (!inquiry.full_name.trim()) {
      newErrors.full_name = "Full name is required";
    }

    if (!inquiry.email.trim()) {
      newErrors.email = "Email is required";
    } else if (/[A-Z]/.test(inquiry.email)) {
      newErrors.email = "Email must not contain capital letters";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inquiry.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!inquiry.phone_number.trim()) {
      newErrors.phone_number = "Phone number is required";
    } else if (!/^\d{11}$/.test(inquiry.phone_number)) {
      newErrors.phone_number = "Phone number must be 11 numbers";
    }

    // if (inquiry.solicitor_type === "firm" && !inquiry.firm_name.trim()) {
    //   newErrors.firm_name = "Firm name is required";
    // }


    if (!inquiry.game_changing_feature.trim()) {
      newErrors.game_changing_feature = "This field is required";
    }

    if (inquiry.refer_colleague && !inquiry.colleague_email.trim()) {
      newErrors.colleague_email = "Colleague email is required";
    } else if (
      inquiry.refer_colleague &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inquiry.colleague_email)
    ) {
      newErrors.colleague_email = "Invalid colleague email format";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    console.log(inquiry);

    try {
      const response = await fetch(`${config.localApiUrl}/api/createInquiry`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(inquiry)
      });
      const result = await response.json();
      if (result.Status === 200) {
        toast.success(result.Message);
        setInquiry({
          full_name: "",
          email: "",
          phone_number: "",
          // solicitor_type: "solo",
          firm_name: "",
          user_count: "2-5",
          current_software: "",
          game_changing_feature: "",
          demo_access_opt_in: "false",
          refer_colleague: "",
          colleague_email: "",
        });
        handleClose();
      } else {
        toast.error(result.Message);
      }
    } catch (error) {
      console.log("Failed to create Data:", error.Message);
      toast.error("Failed to create Data.");
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "phone_number") {
      const cleanedValue = value.replace(/\D/g, "");
      const formattedValue = cleanedValue.slice(0, 11);
      setInquiry({ ...inquiry, phone_number: formattedValue });
    } else {
      setInquiry({ ...inquiry, [name]: type === 'checkbox' ? checked : value });
    }
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };



  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  }, []);

  return (
    <>
      {loading ? (
        <CustomLoader />
      ) : (
        <div className="main-wrapper">
          <div className="background-color">
            <div className="container">
              <div className="banner-wrapper">
                <div className="banner-img">
                  <img src={bannerimg} alt="" />
                </div>
                <div className="banner-text">
                  <h1>Ivy – Fast. Secure. Reliable. Affordable.</h1>
                  <p>Revolutionising Legal Case Management</p>
                </div>
                <div className="join-btn">
                  <button title="Join the Waitlist Today" onClick={handleShow}>
                    <div className="roket_icon" />
                    Join the Waitlist Today
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="built-solicitors-section">
            <div className="container">
              <div className="built-title">
                <h2>Built by Solicitors, for Solicitors.</h2>
                <p>
                  Ivy is the next generation AI powered legal software designed
                  for independent solicitors and firms. Manage cases, draft
                  documents, and streamline workflows—all in one place,
                  completely paperless.
                </p>
              </div>
              <div className="row">
                <div className="col-sm-6 col-6 text-left">
                  <div className="built-list-block">
                    <div className="built-block-img">
                      <img src={icon6} alt="" className="see-icon"/>
                    </div>
                    <div className="built-investment-text">
                      <h2>Fast & Intuitive</h2>
                      <p>
                        Lightning-fast document management and case tracking.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-6 text-left">
                  <div className="built-list-block">
                    <div className="built-block-img">
                      <img src={icon30} alt="" className="see-icon"/>
                    </div>
                    <div className="built-investment-text">
                      <h2>Secure & Reliable</h2>
                      <p>
                        Built with enterprise-grade security and GDPR
                        compliance.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-6 text-left">
                  <div className="built-list-block">
                    <div className="built-block-img">
                      <img src={icon7} alt="" className="see-icon"/>
                    </div>
                    <div className="built-investment-text">
                      <h2>AI-Powered Document Drafting</h2>
                      <p>
                        Generate contracts, letters, and legal documents
                        effortlessly.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-6 text-left">
                  <div className="built-list-block">
                    <div className="built-block-img">
                      <img src={icon16} alt="" className="see-icon"/>
                    </div>
                    <div className="built-investment-text">
                      <h2>Deep Microsoft Office Integration</h2>
                      <p>
                        Work seamlessly with Word and Excel files within Ivy.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-6 text-left">
                  <div className="built-list-block">
                    <div className="built-block-img">
                      <img src={icon8} alt="" className="see-icon"/>
                    </div>
                    <div className="built-investment-text">
                      <h2 className="text-heading">Affordable Pricing</h2>
                      <p>
                        High-performance legal software without the hefty price
                        tag.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-6 text-left">
                  <div className="built-list-block">
                    <div className="built-block-img">
                      <img src={icon17} alt="" className="see-icon"/>
                    </div>
                    <div className="built-investment-text">
                      <h2>Cloud-Based & Accessible Anywhere</h2>
                      <p>
                        Work from any device, whether in the office or on the
                        go.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="join-btn">
                <button title="Join the Waitlist Today" onClick={handleShow}>
                  <div className="roket_icon" />
                  Join the Waitlist Today
                </button>
                <p>Be the first to experience the future of legal tech.</p>
              </div>
            </div>
          </div>
          <div className="why-ivy-section">
            <div className="container">
              <div className="why-title">
                <h2>Why Ivy?</h2>
                <p>
                  Ivy was created by legal professionals who understand the
                  frustrations of existing case management software. Many
                  solicitors find current solutions outdated, slow, and
                  expensive. That’s why we created Ivy—to offer a modern,
                  AI-driven alternative that’s fast, secure, and cost-effective.
                </p>
              </div>
              <div className="row nowrap-list">
                <div className="col-sm-6 col-12 text-left">
                  <div className="why-list-block">
                    <div className="why-block-img">
                      <img src={image1} alt="" />
                    </div>
                    <div className="why-investment-text">
                      <h2>
                        “Finally, a legal software that understands how we work.
                        Ivy makes case management effortless.”
                      </h2>
                      <p>— A practising solicitor</p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-12 text-left">
                  <div className="why-box-block">
                    <div className="why-box">
                      <div className="img">
                        <img src={icon3} alt="" />
                      </div>
                      <h2>Designed for the Modern Lawyer</h2>
                    </div>
                    <div className="why-box">
                      <div className="img">
                        <img src={icon4} alt="" />
                      </div>
                      <h2>Developed with Real Solicitor Feedback</h2>
                    </div>
                    <div className="why-box">
                      <div className="img">
                        <img src={icon5} alt="" />
                      </div>
                      <h2>AI-Powered Efficiency Without Complexity</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="see-action-section">
            <div className="container">
              <div className="see-title">
                <h2>See Ivy in Action</h2>
                <p>
                  Ivy is built to save time, reduce admin, and enhance
                  efficiency.
                </p>
              </div>
              <div className="row nowrap-list">
                <div className="col-sm-6 col-12 text-left text-animation">
                  <div className="see-img">
                    <img src={image2} alt="" />
                  </div>
                </div>
                <div className="col-sm-6 col-12 text-left text-animations">
                  <div className="see-list-block">
                    <div className="built-block-img">
                      <img src={icon18} alt="" className="see-icon" />
                    </div>
                    <h2>Auto-draft legal documents in seconds</h2>
                  </div>
                </div>
              </div>
              <div className="row nowrap-list">
                <div className="col-sm-6 col-12 text-left text-animation">
                  <div className="see-list-block">
                    <div className="built-block-img">
                      <img src={icon19} alt="" className="see-icon" />
                    </div>
                    <h2>Instant case search & retrieval</h2>
                  </div>
                </div>
                <div className="col-sm-6 col-12 text-left text-animations">
                  <div className="see-img">
                    <img src={image3} alt="" />
                  </div>
                </div>
              </div>
              <div className="row nowrap-list">
                <div className="col-sm-6 col-12 text-left text-animation">
                  <div className="see-img">
                    <img src={image2} alt="" />
                  </div>
                </div>
                <div className="col-sm-6 col-12 text-left text-animations">
                  <div className="see-list-block">
                    <div className="built-block-img">
                      <img src={icon15} alt="" className="see-icon" />
                    </div>
                    <h2>One-click document sharing & e-signatures</h2>
                  </div>
                </div>
              </div>
              <div className="row nowrap-list">
                <div className="col-sm-6 col-12 text-left text-animation">
                  <div className="see-list-block">
                    <div className="built-block-img">
                      <img src={icon20} alt=""  className="see-icon"/>
                    </div>
                    <h2>Intelligent task management to keep you on track</h2>
                  </div>
                </div>
                <div className="col-sm-6 col-12 text-left text-animations">
                  <div className="see-img">
                    <img src={image4} alt="" />
                  </div>
                </div>
              </div>
              <div className="join-btn">
                <button
                  title="Join the Waitlist to Get Early Access"
                  // onClick={handleShow}
                  onClick={() => navigate("/lifetime-access")}
                >
                  Join the Waitlist to Get Early Access
                </button>
              </div>
            </div>
          </div>
          <div className="pricing-section">
            <div className="container">
              <div className="pricing-title">
                <h2>Affordable & Transparent Pricing</h2>
                <p>
                  We believe great legal software shouldn’t break the bank. Ivy
                  offers premium features at a fraction of the cost of
                  traditional legal tech.
                </p>
              </div>
              <div className="pricing-box-block">
                <div className="why-box">
                  <div className="img">
                    <img src={icon11} alt="" />
                  </div>
                  <h2>No hidden fees</h2>
                </div>
                <div className="why-box">
                  <div className="img">
                    <img src={icon10} alt="" />
                  </div>
                  <h2>Flexible plans for firms of all sizes</h2>
                </div>
                <div className="why-box">
                  <div className="img">
                    <img src={icon12} alt="" />
                  </div>
                  <h2>Simple & transparent pricing</h2>
                </div>
                <div className="why-box">
                  <div className="img">
                    <img src={icon13} alt="" />
                  </div>
                  <h2>Limited Early-Bird Discounts Available</h2>
                </div>
              </div>
              <div className="join-btn">
                <button
                  title="Join the Waitlist to secure your spot now"
                  onClick={handleShow}
                >
                  Join the Waitlist to secure your spot now
                </button>
              </div>
            </div>
          </div>
          <div className="secure-section">
            <div className="container">
              <div className="secure-title">
                <h2>Fast. Secure. Reliable.</h2>
                <p>
                  Ivy is GDPR-compliant, fully secure, and designed to handle
                  high-volume legal work. Whether you run a small practice or
                  manage a large firm, Ivy scales to your needs.
                </p>
              </div>
              <div className="secure-box-block">
                <div className="why-box">
                  <div className="img">
                    <img src={icon2} alt="" />
                  </div>
                  <h2>Data Security & Compliance at the Core</h2>
                </div>
                <div className="why-box">
                  <div className="img">
                    <img src={icon14} alt="" />
                  </div>
                  <h2>Seamless Migration from Existing Software</h2>
                </div>
                <div className="why-box">
                  <div className="img">
                    <img src={icon1} alt="" />
                  </div>
                  <h2>Optimised for Speed & Performance</h2>
                </div>
              </div>
              <h2>Ivy is launching soon</h2>
              <div className="join-btn">
                <button title="Be the first to know" onClick={handleShow}>
                  Be the first to know
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <Modal show={show} onHide={handleClose} className="join_the_waitlist">
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Title>Ivy is launching soon.</Modal.Title>
        <Modal.Body>
          <form className="join-modal" onSubmit={handleSubmit}>
            <div className="form-group">
              <div className="user-icon" />
              <input
                type="text"
                placeholder="Full Name"
                className="form-control"
                onChange={handleChange}
                name="full_name"
                value={inquiry.full_name}
              />
              {errors.full_name && <p className="text-red-500 text-sm">{errors.full_name}
              </p>}
            </div>

            <div className="form-group">
              <div className="email-icon" />
              <input
                type="email"
                placeholder="Email address"
                className="form-control"
                onChange={handleChange}
                name="email"
                value={inquiry.email}
              />
              {errors.email && <p className="text-red-500 text-sm">{errors.email}
              </p>}
            </div>

            <div className="form-group">
              <div className="phone-icon" />
              <input
                type="tel"
                placeholder="Phone Number"
                className="form-control"
                onChange={handleChange}
                name="phone_number"
                value={inquiry.phone_number}
              />
              {errors.phone_number && <p className="text-red-500 text-sm">{errors.phone_number}
              </p>}
            </div>
            {/* <p className="text-head">Are you a solo solicitor or part of a firm?</p> */}

            {/* <div className="custom-select-wrapper">
              <select className="custom-select" name="solicitor_type"
                value={inquiry.solicitor_type}
                onChange={handleChange}>
                <option value="solo">Solo</option>
                <option value="firm">Firm</option>
              </select>

            </div> */}

            <div className="form-group">
              <input
                type="text"
                placeholder="Firm Name"
                className="form-control firm-name"
                onChange={handleChange}
                name="firm_name"
                value={inquiry.firm_name}
              />
              {errors.firm_name && <p className="text-red-500 text-sm">{errors.firm_name}
              </p>}
            </div>

            <p className="text-head">how many users you have in your firm ?</p>
            <div className="custom-select-wrapper">
              <select className="custom-select" name="user_count"
                value={inquiry.user_count}
                onChange={handleChange}>
                <option>2-5</option>
                <option>6-10</option>
                <option>10+</option>
              </select>
            </div>
            <p className="text-head">Are you currently using any legal software? If yes, which one?</p>
            <div className="form-group">
              <input
                type="text"
                placeholder="Enter software name"
                className="form-control firm-name"
                name="current_software"
                value={inquiry.current_software}
                onChange={handleChange}
              />
            </div>
            <p className="text-head">What feature would be a game changer for you in legal software?</p>

            <textarea
              placeholder="Feature description here…"
              className="form-control"
              name="game_changing_feature"
              value={inquiry.game_changing_feature}
              onChange={handleChange}
            />
            {errors.game_changing_feature && <span className="text-red-500 text-sm">{errors.game_changing_feature}
            </span>}
            <div className="custom-checkbox-block">

              {/* <div className="custom-checkbox">
                <Form.Check aria-label="option 1" name="demo_access_opt_in"
                  checked={inquiry.demo_access_opt_in}
                  onChange={handleChange} defaultChecked />
                <label>Opt in for early demo beta access</label>
              </div> */}

              <div className="custom-checkbox">
                <Form.Check aria-label="option 1" name="refer_colleague"
                  checked={inquiry.refer_colleague}
                  onChange={handleChange} />
                <label>I'd like to refer a colleague</label>
              </div>
            </div>
            {inquiry.refer_colleague && (
              <div className="form-group">
                <div className="email-icon" />
                <input
                  type="email"
                  placeholder="Enter your colleague's email"
                  className="form-control"
                  name="colleague_email"
                  value={inquiry.colleague_email}
                  onChange={handleChange}
                />
                {errors.colleague_email && <p className="text-red-500 text-sm">{errors.colleague_email}
                </p>}
              </div>
            )}

            <button
              type="submit"
              className="btn btn-primary"

            >
              Join Waitlist
            </button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Home;
